import { render, staticRenderFns } from "./DialogAdvances.vue?vue&type=template&id=52c6a47c&scoped=true&"
import script from "./DialogAdvances.vue?vue&type=script&lang=js&"
export * from "./DialogAdvances.vue?vue&type=script&lang=js&"
import style0 from "./DialogAdvances.vue?vue&type=style&index=0&id=52c6a47c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c6a47c",
  null
  
)

export default component.exports